var sizeVariants = {
  xs: 'styles_xs__h6ljxk0',
  sm: 'styles_sm__h6ljxk1',
  md: 'styles_md__h6ljxk2',
  lg: 'styles_lg__h6ljxk3',
  xl: 'styles_xl__h6ljxk4'
};
export { sizeVariants };
